var Sound3D = (function () {
    function Sound3D() {
    }
    return Sound3D;
}());
export { Sound3D };
